import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get contacts
 * */
export function* getCountries() {
    const response = yield call(api.getCountries);
    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_COUNTRIES.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_COUNTRIES.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCountries() {
    while (true) {
        yield take(actionTypes.GET_COUNTRIES.REQUEST);
        yield fork(getCountries);
    }
}

export default [
    watchGetCountries,
];



// WEBPACK FOOTER //
// ./app/sagas/countries.js